var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',[_vm._m(0),_c('h6',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.content))])]),_c('div',[_c('button',{on:{"click":_vm.goto}},[_vm._v("立即进入")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"el-icon-document-copy"})])
}]

export { render, staticRenderFns }